export const SOCKET_CHECK_MESSAGE_TYPE = "SOCKET_CHECK_MESSAGE_TYPE";
export const SOCKET_UPDATE_NOTIFIACTIONS_BADGE =
  "SOCKET_UPDATE_NOTIFIACTIONS_BADGE";
